module.exports = __webpack_public_path__ + "static/img/img_tip5.21770a15.png";